import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg, CATEGORIES } from "@/lib/api";

const EMPTY = { name: "", date: new Date().toISOString().slice(0, 10), location: "", category: "corrida", price: 15, package_price: 91, description: "" };

export function EventForm({ open, onClose, initial, onSaved }) {
  const [f, setF] = useState(initial ? { ...EMPTY, ...initial, package_price: initial.package_price ?? 91 } : EMPTY);
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const input = "mt-1 w-full h-11 px-3 rounded-md border border-zinc-200 bg-white focus:outline-none focus:ring-2 focus:ring-[#0055FF]";

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const body = { name: f.name, date: f.date, location: f.location, category: f.category, description: f.description || "", price: Number(f.price), package_price: Number(f.package_price) };
      const { data } = initial ? await api.put(`/admin/events/${initial.id}`, body) : await api.post("/admin/events", body);
      toast.success(initial ? "Evento atualizado" : "Evento criado");
      onSaved(data);
      onClose();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="event-form-dialog">
        <DialogTitle className="font-display text-2xl">{initial ? "Editar evento" : "Novo evento"}</DialogTitle>
        <form onSubmit={submit} className="space-y-3">
          <div><label className="text-sm font-medium">Nome do evento</label><input required value={f.name} onChange={set("name")} data-testid="event-name-input" className={input} placeholder="Ex: Maratona de SP 2026" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><label className="text-sm font-medium">Data</label><input type="date" required value={f.date} onChange={set("date")} data-testid="event-date-input" className={input} /></div>
            <div><label className="text-sm font-medium">Preço por foto (R$)</label><input type="number" step="0.01" min="0" required value={f.price} onChange={set("price")} data-testid="event-price-input" className={input} /></div>
          </div>
          <div>
            <label className="text-sm font-medium">Preço do pacote "todas as minhas fotos" (R$)</label>
            <input type="number" step="0.01" min="0" required value={f.package_price} onChange={set("package_price")} data-testid="event-package-price-input" className={input} />
            <p className="mt-1 text-xs text-zinc-500">Se o cliente escolher fotos que somam mais que esse valor, paga só o pacote. Use 0 para desativar.</p>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div><label className="text-sm font-medium">Local</label><input value={f.location} onChange={set("location")} data-testid="event-location-input" className={input} /></div>
            <div>
              <label className="text-sm font-medium">Categoria</label>
              <select value={f.category} onChange={set("category")} data-testid="event-category-select" className={input}>
                {Object.entries(CATEGORIES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
              </select>
            </div>
          </div>
          <button disabled={saving} data-testid="event-save-btn" className="w-full h-12 rounded-md bg-[#0055FF] hover:bg-[#0040CC] disabled:opacity-60 text-white font-semibold">
            {saving ? "Salvando…" : "Salvar"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
